export const left_content_first_text =
  "pl-3 sm:pl-0 text-base font-medium text-gray-500";
export const left_content_second_text =
  "pl-3 sm:pl-0 font-bold text-gray-900 text-21px capitalize";
